<div class="page-layout blank p-24" fusePerfectScrollbar>

    <h2>Documents Page</h2>

</div>
